"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestIdContext = void 0;
const react_1 = require("react");
exports.TestIdContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=context.js.map